export const createOrdersRequests = (client) => ({
    listOrders: async (params) => {
        const { data, meta, links } = await client.api.get("orders", {
            params: params,
        });
        return { data, meta, links };
    },
    findOrder: async (params) => {
        const { data } = await client.api.request({
            method: "GET",
            type: "orders",
            url: `orders/${params?.filter?.id}`,
            params: params,
        });
        return { data };
    },
    getOrderCost: async (payload) => {
        const { data } = await client.api.request({
            method: "GET",
            type: "orders",
            url: `orders/${payload?.id}/amount`,
            params: {
                ...(payload.discount_code_id && {
                    discount_code_id: payload.discount_code_id,
                }),
            },
        });
        return { data };
    },
    downloadOrdersReport: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "orders",
            url: `/orders/report`,
            body: payload,
        });
        return { data };
    },
    downloadOrderProforma: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "orders",
            url: `/orders/${payload.id}/invoice`,
            body: {
                data: {
                    attributes: payload,
                },
            },
        });
        return { data };
    },
    removeOrderItem: async (payload) => {
        const { data } = await client.api.request({
            method: "DELETE",
            type: "orders",
            url: `/orders/${payload.orderId}/order_items/${payload.orderItemId}`,
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map